import { render, staticRenderFns } from "./EditSucai.vue?vue&type=template&id=dcc0e7c0&scoped=true"
import script from "./EditSucai.vue?vue&type=script&lang=js"
export * from "./EditSucai.vue?vue&type=script&lang=js"
import style0 from "./EditSucai.vue?vue&type=style&index=0&id=dcc0e7c0&prod&lang=css"
import style1 from "./EditSucai.vue?vue&type=style&index=1&id=dcc0e7c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc0e7c0",
  null
  
)

export default component.exports